/**
 * Constants for landing page configuration
 */

import { ModeOption, AgeOption } from "../types/landing";

export const MODE_OPTIONS: ModeOption[] = [
  {
    value: "explorer",
    label: "Explorer (Kids)",
    description: "Fun, gentle guidance for children ages 6–11 to notice and name their feelings",
    icon: "/faf - kids icon outline.png",
    color: "brand-accent-mint",
  },
  {
    value: "adult",
    label: "Adult",
    description: "Explore emotions through body awareness — notice how feelings show up physically",
    icon: "/faf  - adult icon outline.png",
    color: "brand-secondary",
  },
  {
    value: "admin",
    label: "Admin",
    description: "Support children's emotional growth with insights and monitoring tools",
    icon: "/faf - admin icon outline.png",
    color: "highlight",
  },
];

export const AGE_OPTIONS: AgeOption[] = [
  { value: "6-7", label: "6-7 years" },
  { value: "8-9", label: "8-9 years" },
  { value: "10-11", label: "10-11 years" },
];

export const LEGAL_NOTICE = {
  title: "Important Notice",
  content:
    "This app is designed for children ages 6–11. By continuing, a parent or guardian consents to their child using this app. No personal information will be collected without explicit parental consent.",
  consentLabel: "I understand and consent",
};

export const APP_CONFIG = {
  title: "Find a Feeling",
  subtitle: "Discover feelings through your body, one step at a time",
  continueButtonText: "Continue →",
};
